module.exports = __webpack_public_path__ + "img/e36ac85.svg";